import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07988742"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "padding": "8px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "chart"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, _toDisplayString($data.title), 1), _hoisted_2]), _createVNode(_component_van_cell, {
      "is-link": "",
      title: $data.menu.curItem.name,
      onClick: $options.onMenuClick
    }, null, 8, ["title", "onClick"]), _createVNode(_component_van_row, {
      class: "row",
      type: "flex",
      justify: "space-around"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_createTextVNode("净值日期")]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_createTextVNode("单位净值")]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_createTextVNode("累计净值")]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "6"
      }, {
        default: _withCtx(() => [_createTextVNode("涨跌幅(%)")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      "immediate-check": false,
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      isPaging: false,
      onOnListDataChange: $options.onListDataChange
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_divider, {
        style: {
          padding: '0px',
          margin: '8px'
        }
      }), _createVNode(_component_van_row, {
        class: "row"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_col, {
          span: "6"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.publicDate), 1)]),
          _: 2
        }, 1024), _createVNode(_component_van_col, {
          span: "6"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.netValue), 1)]),
          _: 2
        }, 1024), _createVNode(_component_van_col, {
          span: "6"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.accumulateNetValue), 1)]),
          _: 2
        }, 1024), _createVNode(_component_van_col, {
          span: "6"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.netValueDiff) + "%", 1)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1024)]),
      _: 1
    }, 8, ["request", "requestParameter", "onOnListDataChange"]), _createVNode(_component_van_action_sheet, {
      show: $data.menu.showMenu,
      "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.menu.showMenu = $event),
      description: "选择查询范围",
      actions: $data.menu.menuItems,
      onSelect: $options.onMenuSelect
    }, null, 8, ["show", "actions", "onSelect"])]),
    _: 1
  });
}